// extracted by mini-css-extract-plugin
export default {"pill":"TagPill_pill__jxloQ","sm":"TagPill_sm__eQewr","md":"TagPill_md__vZrN4","name":"TagPill_name__Oo4v1","removeButton":"TagPill_removeButton__1UHvv"};